var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ranking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.78016 9.33301H2.66683C1.9335 9.33301 1.3335 9.93301 1.3335 10.6663V14.6663H5.78016V9.33301Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.88677 6.66699H7.10677C6.37344 6.66699 5.77344 7.26699 5.77344 8.00033V14.667H10.2201V8.00033C10.2201 7.26699 9.62677 6.66699 8.88677 6.66699Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3335 11.333H10.2202V14.6663H14.6669V12.6663C14.6669 11.933 14.0669 11.333 13.3335 11.333Z",
    stroke: "#173D33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.34682 1.37988L8.70015 2.08655C8.74682 2.18655 8.87349 2.27988 8.98015 2.29321L9.62015 2.39988C10.0268 2.46655 10.1268 2.76653 9.83349 3.0532L9.33349 3.5532C9.24682 3.63987 9.20015 3.79987 9.22682 3.91321L9.36682 4.52655C9.48015 5.01322 9.22015 5.19989 8.79349 4.94655L8.19349 4.59322C8.08682 4.52655 7.90682 4.52655 7.80015 4.59322L7.20015 4.94655C6.77349 5.19989 6.51349 5.01322 6.62682 4.52655L6.76682 3.91321C6.79349 3.79987 6.74682 3.6332 6.66015 3.5532L6.16682 3.05987C5.87349 2.76654 5.96682 2.4732 6.38015 2.40653L7.02015 2.29989C7.12682 2.27989 7.25349 2.18655 7.30015 2.09322L7.65349 1.38653C7.84682 0.999868 8.15349 0.999882 8.34682 1.37988Z",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.370ad30f0b7aa1f46c597ce4dfc62dc3.svg";
export { ForwardRef as ReactComponent };